export const APP_BASE_URL = '';

export const MESSAGE_STATUS = {
  FAILED: 'failed',
  SUCCESS: 'success',
  PROGRESS: 'progress',
};

export const MESSAGE_TYPE = {
  INCOMING: 0,
  OUTGOING: 1,
  ACTIVITY: 2,
  TEMPLATE: 3,
};

// Map string message_type values to numbers (backend sometimes returns strings)
const MESSAGE_TYPE_MAP = {
  incoming: MESSAGE_TYPE.INCOMING,
  outgoing: MESSAGE_TYPE.OUTGOING,
  activity: MESSAGE_TYPE.ACTIVITY,
  template: MESSAGE_TYPE.TEMPLATE,
};

export const normalizeMessageType = messageType => {
  if (typeof messageType === 'number') return messageType;
  return MESSAGE_TYPE_MAP[messageType] ?? MESSAGE_TYPE.INCOMING;
};

export const WOOT_PREFIX = 'chatwoot-widget:';
